import { useState } from 'react'
import { ColumnFiltersState, OnChangeFn } from '@tanstack/react-table'
import { NetworkStatus } from '@apollo/client'
import { FnsTable } from '@/features/forms-and-surveys/components'
import { useSurveys, useForms } from '@/features/forms-and-surveys/hooks'
import { useFnsMode } from '@/features/forms-and-surveys/hooks/use-fns-mode'

// Survey List Component
function SurveyList({
  pagination,
  columnFilters,
  setColumnFilters,
  setPagination,
}: {
  pagination: { pageIndex: number; pageSize: number }
  columnFilters: ColumnFiltersState
  setColumnFilters: OnChangeFn<ColumnFiltersState>
  setPagination: OnChangeFn<{ pageIndex: number; pageSize: number }>
}) {
  const { data, loading, refetch, networkStatus } = useSurveys({
    limit: pagination.pageSize,
    skip: pagination.pageIndex * pagination.pageSize,
  })

  return (
    <FnsTable
      data={data?.fnsServiceGetSurveysForAdmin?.data || []}
      total={data?.fnsServiceGetSurveysForAdmin?.total || 0}
      loading={loading}
      refetch={refetch}
      refetching={networkStatus === NetworkStatus.refetch}
      pagination={pagination}
      setPagination={setPagination}
      columnFilters={columnFilters}
      setColumnFilters={setColumnFilters}
    />
  )
}

// Form List Component
function FormList({
  pagination,
  columnFilters,
  setColumnFilters,
  setPagination,
}: {
  pagination: { pageIndex: number; pageSize: number }
  columnFilters: ColumnFiltersState
  setColumnFilters: OnChangeFn<ColumnFiltersState>
  setPagination: OnChangeFn<{ pageIndex: number; pageSize: number }>
}) {
  const { data, loading, refetch, networkStatus } = useForms({
    limit: pagination.pageSize,
    skip: pagination.pageIndex * pagination.pageSize,
  })

  return (
    <FnsTable
      data={data?.fnsServiceGetFormsForAdmin?.data || []}
      total={data?.fnsServiceGetFormsForAdmin?.total || 0}
      loading={loading}
      refetch={refetch}
      refetching={networkStatus === NetworkStatus.refetch}
      pagination={pagination}
      setPagination={setPagination}
      columnFilters={columnFilters}
      setColumnFilters={setColumnFilters}
    />
  )
}

function FnsListPage() {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([])
  const mode = useFnsMode()

  // Conditionally render the appropriate component based on mode
  if (mode === 'survey') {
    return (
      <SurveyList
        pagination={pagination}
        columnFilters={columnFilters}
        setColumnFilters={setColumnFilters}
        setPagination={setPagination}
      />
    )
  }

  return (
    <FormList
      pagination={pagination}
      columnFilters={columnFilters}
      setColumnFilters={setColumnFilters}
      setPagination={setPagination}
    />
  )
}

export default FnsListPage
